/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Mitra_NameInputs */

const en_cp_p_mitra_name = /** @type {(inputs: Cp_P_Mitra_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Partner`)
};

const id_cp_p_mitra_name = /** @type {(inputs: Cp_P_Mitra_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampus Mitra`)
};

/**
* | output |
* | --- |
* | "Campus Partner" |
*
* @param {Cp_P_Mitra_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_mitra_name = /** @type {((inputs?: Cp_P_Mitra_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Mitra_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_mitra_name(inputs)
	return en_cp_p_mitra_name(inputs)
});